import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { UnitLabel } from "./UnitLabel";

interface UnitLabelContainerProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: UnitLabelContainerProps) => {
    const { bindingPath, viewModelSelect } = ownProps;

    return {
        label: viewModelSelect.controlModel(state, bindingPath).value,
        isReadOnly: state.settings.isReadOnly,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: UnitLabelContainerProps) => {
    const { bindingPath } = ownProps;

    return { onChangeLabel: (nextLabel: string) => dispatch(setToModel(bindingPath, "value", nextLabel)) };
};

export const UnitLabelContainer = withResolvePaths(
    withViewModelSelect(
        connect(mapStateToProps, mapDispatchToProps)(withTestPageObjectRegistration(withControlDebugInfo(UnitLabel)))
    )
);
